import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M16.981 17.592c-2.111 2.372-5.08 3.055-5.08 3.055s-6.273-2.135-6.334-8.425c0 0-.018-5.868.416-6.071.468-.234 3.62.544 6.894-2.25 2.932 3.12 5.953 2.665 6.361 2.944 0 0-.27 5.145-2.19 3.27-1.366-1.296 1.307-2.574 1.88-.449.248.851.005 1.774-.645 2.352a1.94 1.94 0 0 1-1.525.5"
    />
    <path
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m9.491 12.358 4.993.262M11.857 14.986l.262-4.993"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const PsychotherapyIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
